import request from '@/utils/request'

const BaseUrl = '/bs-project-milestone'

// 保存任务
export function addForm(data) {
    return request({
        url: "/bs-project-milestone/save",
        method: 'post',
        data
    })
}

// 通过id删除任务
export function deleteId(id) {
    return request({
        url: `${BaseUrl}/${id}`,
        method: 'delete',
    })
}

// 通过id获取详情
export function idQuery(id) {
    return request({
        url: `${BaseUrl}/${id}`,
        method: 'get',
    })
}

// 修改任务
export function updatedForm(data) {
    return request({
        url: "/bs-project-milestone",
        method: 'put',
        data
    })
}